import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AboutModel } from '../models/about-model';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import * as aboutActions from '../actions/about.actions';

@Injectable()
export class AboutService {

  constructor(private store: Store<ApplicationState>) { }

  loadAboutData(product: string): void {
    this.store.dispatch(new aboutActions.Load(product));
  }

  getAboutLoaded(): Observable<boolean> {
    return this.store.pipe(select((state) => state.about.loaded));
  }

  getAboutDetails(): Observable<AboutModel> {
    return this.store.pipe(select((state) => state.about.aboutDetails));
  }

  getVersionNumber(): Observable<string> {
    return this.store.pipe(select((state) => state.about.versionNumber));
  }

}
